import { SWITCH_LANG } from "./types";

export const switchLang = (payload) => {
  return {
    type: SWITCH_LANG,
    payload,
  };
};
